module.exports = __webpack_public_path__ + "img/fangtan2-1.6493e4ff.png";